import { Button, Menu } from "@mantine/core";
import { useFormRender } from "../hooks/useFormRender";
import { useServerApi } from "../hooks/userServerApi";
import { showNotification } from "@mantine/notifications";
import { useState } from "react";
import { IconPrinter, IconDownload, IconChevronDown } from "@tabler/icons";

const ClientStatementButton = ({ mainForm }) => {
  const [api] = useServerApi();
  const [isLoading, setIsLoading] = useState(false);

  const handleAction = async (action) => {
    try {
      const id = mainForm?.values._id;
      if (!id) return;
      setIsLoading(true);

      if (action === "print") {
        const result = await api.Client.printWaitingStatement(id);
        if (!result.success) throw result;
        const url = result.data.url;
        window.open(url, "_blank");
      } else if (action === "download") {
        const result = await api.Client.printWaitingStatement(id, "docx");
        if (!result.success) throw result;
        const url = result.data.url;
        window.open(url, "_blank");
      }
    } catch (error) {
      console.log(error);
      showNotification({
        title: "Error",
        message: error.message,
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Menu shadow="md" width={200}>
        <Menu.Target>
          <Button
            fullWidth
            color="blue"
            loading={isLoading}
            rightIcon={<IconChevronDown size={16} />}
          >
            Client Statement
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            icon={<IconPrinter size={16} />}
            onClick={() => handleAction("print")}
            disabled={isLoading}
          >
            Print
          </Menu.Item>
          <Menu.Item
            icon={<IconDownload size={16} />}
            onClick={() => handleAction("download")}
            disabled={isLoading}
          >
            Download
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      {/* {renderForm()} */}
    </>
  );
};

export default ClientStatementButton;
